(function () {
  'use strict';

  const WIDGET_SELECTOR = 'cart-drawer .dr-gifts[data-dr-gifts-widget], .dr-gifts[data-dr-gifts-widget]';
  const MEMBERS_UI_STATE_KEY = 'drGifts.membersUiState';

  function getConfig(config) {
    return config || window.DR_GIFTS_CONFIG || null;
  }

  function isModuleEnabled(config, key) {
    const modules = getConfig(config)?.modules || {};
    return modules[key] !== false;
  }

  function getAvailableTabs(config) {
    const resolvedConfig = getConfig(config) || {};
    const tabs = [];
    const giftsEnabled =
      (isModuleEnabled(resolvedConfig, 'free') && Array.isArray(resolvedConfig.free) && resolvedConfig.free.length > 0) ||
      (isModuleEnabled(resolvedConfig, 'bonus1') && Array.isArray(resolvedConfig.bonus?.variants) && resolvedConfig.bonus.variants.length > 0) ||
      (isModuleEnabled(resolvedConfig, 'bonus2') && Array.isArray(resolvedConfig.bonus2?.variants) && resolvedConfig.bonus2.variants.length > 0) ||
      (isModuleEnabled(resolvedConfig, 'bonus3') && Array.isArray(resolvedConfig.bonus3?.variants) && resolvedConfig.bonus3.variants.length > 0);

    if (giftsEnabled) tabs.push('gifts');
    if (isModuleEnabled(resolvedConfig, 'membersTab')) tabs.push('members');
    if (isModuleEnabled(resolvedConfig, 'newMemberTab')) tabs.push('new-customer');
    if (!tabs.length) tabs.push('gifts');
    return tabs;
  }

  function normalizeTab(tab, config) {
    const value = String(tab || '').trim();
    const availableTabs = getAvailableTabs(config);
    if ((value === 'members' || value === 'new-customer' || value === 'gifts') && availableTabs.includes(value)) {
      return value;
    }
    return availableTabs[0];
  }

  function getWidget(root) {
    if (root && typeof root.querySelector === 'function') {
      const localWidget = root.querySelector('.dr-gifts[data-dr-gifts-widget]');
      if (localWidget) return localWidget;
    }
    return document.querySelector(WIDGET_SELECTOR);
  }

  function applyTabState(widget, activeTab, config) {
    if (!widget) return false;
    const normalizedTab = normalizeTab(activeTab, config);
    widget.setAttribute('data-dr-active-tab', normalizedTab);
    widget.querySelectorAll('[data-dr-tab]').forEach((tabButton) => {
      const isActive = tabButton.getAttribute('data-dr-tab') === normalizedTab;
      tabButton.classList.toggle('dr-gifts__tab--active', isActive);
      tabButton.setAttribute('aria-selected', String(isActive));
      tabButton.setAttribute('tabindex', isActive ? '0' : '-1');
    });
    widget.querySelectorAll('[data-dr-panel]').forEach((panel) => {
      const isActive = panel.getAttribute('data-dr-panel') === normalizedTab;
      panel.toggleAttribute('hidden', !isActive);
    });
    if (normalizedTab !== 'gifts') {
      widget.classList.remove('is-picker-open');
    }
    return true;
  }

  function readMembersUiState(config) {
    try {
      const raw = sessionStorage.getItem(MEMBERS_UI_STATE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return null;
      return {
        activeTab: normalizeTab(parsed.activeTab, config),
        membersOpen: parsed.membersOpen === true,
        returnPending: parsed.returnPending === true,
      };
    } catch (_) {
      return null;
    }
  }

  function writeMembersUiState(nextState, config) {
    try {
      const current = readMembersUiState(config) || { activeTab: 'gifts', membersOpen: false, returnPending: false };
      const merged = {
        activeTab: typeof nextState?.activeTab !== 'undefined' ? normalizeTab(nextState.activeTab, config) : current.activeTab,
        membersOpen: typeof nextState?.membersOpen === 'boolean' ? nextState.membersOpen : current.membersOpen,
        returnPending: typeof nextState?.returnPending === 'boolean' ? nextState.returnPending : current.returnPending,
      };
      sessionStorage.setItem(MEMBERS_UI_STATE_KEY, JSON.stringify(merged));
      return merged;
    } catch (_) {
      return null;
    }
  }

  window.drCartGiftsUi = {
    WIDGET_SELECTOR,
    MEMBERS_UI_STATE_KEY,
    getWidget,
    getAvailableTabs,
    normalizeTab,
    applyTabState,
    readMembersUiState,
    writeMembersUiState,
  };
})();
